module.exports = __webpack_public_path__ + "static/media/greetingPerson.c3af1b87.jpg";